export default __webpack_public_path__ + "static/media/img-sustainability.1a53b6f6.jpg";